import { defaultDatePickerStrings, IDatePickerStrings } from '@fluentui/react/lib/components/DatePicker';

export const PolandId = 2;
export const MinimumAge = 16;
export const DatePickerStrings = {
    pl: {
        months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
        shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
        days: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
        shortDays: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
        goToToday: 'Przejdź do dzisiaj',
        prevMonthAriaLabel: 'Przejdź do poprzedniego miesiąca',
        nextMonthAriaLabel: 'Przejdź do następnego miesiąca',
        prevYearAriaLabel: 'Przejdź do poprzedniego roku',
        nextYearAriaLabel: 'Przejdź do następnego roku'
    } as IDatePickerStrings,
    en: defaultDatePickerStrings as IDatePickerStrings
};

export const SigningContractType = {
    OwnQualifiedSignature: 'Własny podpis kwalifikowany',
    SigniusQualifiedSignature: 'Podpisanie podpisem kwalifikowanym poprzez platformę SIGNIUS',
    InPersonAtTheOffice: 'Osobiste podpisanie umowy w biurze w Gliwicach'
};
